module.exports = __webpack_public_path__ + "img/mar_del_plata.33de7d65.jpg";